<template>
  <div
    id="_qn_tel_intv_header"
    class="bg-primary row no-wrap justify-between items-center"
  >
    <section class="admin-header-title">
      浙江省小微企业调查2021 ｜ 电访员
    </section>

    <section class="row items-center full-height">
      <div class="admin-header-user-profile full-height row items-center">
        <UserPre />
      </div>
    </section>
  </div>
</template>

<script>
export default {
  components: {
    UserPre: () => import("@/components/user/UserPre"),
  },
};
</script>

<style lang="scss">
@import "@/styles/quasar";

#_qn_tel_intv_header {
  position: fixed;
  padding-left: 70px;
  padding-right: 20px;
  color: #fff;
  font-weight: bold;
  &::before {
    content: "";
    position: absolute;
    left: 0%;
    height: 100%;
    background-color: $secondary;
    width: 70px;
    border-left: 20px solid $tailong-yellow;
  }

  &::after {
    content: "";
    position: absolute;
    right: 0;
    height: 100%;
    background-color: $tailong-dark-blue;
    width: 20px;
  }
}
.admin-header-title {
  font-size: 1.2rem;
  padding-left: 10px;
}

.admin-header-user-profile {
  background-color: $tailong-blue;
  padding: 0 40px;
}
.admin-header-user-profile-avatar {
  color: $primary;
  box-shadow: $shadow-4;
}
</style>
